export const AVAILABLE_MEASUREMENTS = [
  ['weight'],
  ['chest'],
  ['waist'],
  ['hip'],
  ['bodyFat'],
  ['muscleMass'],
  ['visceralFat'],
];
